import { render } from "./TopbarMain.vue?vue&type=template&id=81378ce4"
import script from "./TopbarMain.vue?vue&type=script&lang=js"
export * from "./TopbarMain.vue?vue&type=script&lang=js"
script.render = render

export default script